/* eslint-disable */
import React, {useState} from 'react';

import "contents/assets/scss/page/student.scss";
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopClassRegister from './_PopClassRegister';
import PopClassChange from './_PopClassChange';
function Assignment() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '미수료자', value: 1},
    {title: '원거리', value: 2},
    {title: '집중관리 대상', value: 3},
    {title: '승인불가', value: 4},
    {title: '승인완료', value: 5}
  ];
  const [modalClassRegisterOpen, setModalClassRegisterOpen] = useState(false); //수업등록
  const [modalClassChangeOpen, setModalClassChangeOpen] = useState(false);
  return (
    <main className="com_container p_assignment">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_4">배정 보고서</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalClassRegisterOpen(true)} className="com_btn orange s btn_plus">
              수업 등록
            </button>
            <button onClick={() => setModalClassChangeOpen(true)} className="com_btn orange s btn_plus">
              수업 변경 - 확인용
            </button>
            <button className="com_btn orange s btn_plus">학생 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              </div>
              <button className="com_btn s btn_request red">내 요청</button>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">국어</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영어</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">수학</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">과탐</label>
                  <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">사탐</label>
                  <input type="radio" name="rdo" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">수시</label>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="교사명 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th> 구분</th>
                  <th>등록자</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>수업 지역</th>
                  <th>배정 교사</th>
                  <th>교사 거주지</th>
                  <th>비고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td className="td_date">2022.08.25 12:30</td>
                  <td>미수료자</td>
                  <td>가길동102</td>
                  <td>학생192</td>
                  <td>수학</td>
                  <td>경기도 수원시</td>
                  <td><span className='btn_link'>김선생120</span></td>
                  <td>경기도 용인시</td>
                  <td className="td_red">
                    승인 불가 <br />
                    2023.03.03
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td>집중대상 관리</td>
                      <td>가길동102</td>
                      <td>학생192</td>
                      <td>수학</td>
                      <td>경기도 수원시</td>
                      <td><span className='btn_link'>김선생120</span></td>
                      <td>경기도 용인시</td>
                      <td className="td_point">
                        승인
                        <br />
                        2023.03.03
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 담당 학생 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <button className="btn_edit" />
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name com_blue_txt">홍길동103 </button>
                    <span className="desc com_blue_txt"> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont com_blue_txt">과탐</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">회차 / 타임</span>
                  <span className="cont">16회 / 2T</span>
                </div>
                <div className="info">
                  <span className="tit">완성수업</span>
                  <span className="cont">Y</span>
                </div>
                <div className="info">
                  <span className="tit">수업 시간 / 방법</span>
                  <span className="cont">30분 / 대면</span>
                </div>
                <div className="info">
                  <span className="tit">비교수업</span>
                  <span className="cont">N</span>
                </div>
                <div className="info">
                  <span className="tit">동시수업</span>
                  <span className="cont">김학생103, 최학생123, 최학생105</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">DC코드 / 할인금액</span>
                  <span className="cont">형제할인 5%ㆍ45,000</span>
                </div>
                <div className="info">
                  <span className="tit">1회 수업료</span>
                  <span className="cont">95,000</span>
                </div>
                <div className="info">
                  <span className="tit">수업료</span>
                  <span className="cont com_blue_txt">2,495,000</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업지역</span>
                  <span className="cont com_blue_txt">경기도 성남시 분당구 백형동 3214-345</span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">교사명</span>
                  <span className="cont">김교사102</span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <span className="cont">010-2020-0000</span>
                </div>
                <div className="info">
                  <span className="tit">거주지</span>
                  <span className="cont">경기도 용인시</span>
                </div>
                <div className="info">
                  <span className="tit">1순위 수업지역</span>
                  <span className="cont">경기도 용인시</span>
                </div>
                <div className="info">
                  <span className="tit">2순위 수업지역</span>
                  <span className="cont">경기도 용인시</span>
                </div>
                <div className="info">
                  <span className="tit">현재 시수</span>
                  <span className="cont com_blue_txt">특별시수ㆍ45,000</span>
                </div>
              </div>
            </div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="30%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    (4T) <br />
                    원거리 배정 상황
                  </th>
                  <td className="td_left">
                    원거리 배정 처음 <br />
                    <span className='btn_link'>김학생103</span>ㆍ경기도 수원ㆍ2T l 수업중
                    <br />
                    <span className='btn_link'>최학생405</span>ㆍ경기도 은평구ㆍ1T l 수업 완료
                    <br />
                    <span className='btn_link'>김학생103</span>ㆍ경기도 수원ㆍ2T l 수업중
                  </td>
                </tr>
                <tr>
                  <th>원거리 시수</th>
                  <td className="td_left">
                    <div className="check type_col">
                      <input type="radio" name="rdo" id="rdo_03" className="com_chk circle" />
                      <label htmlFor="rdo_03">+ 5,000원 적용</label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>배정담당 의견</th>
                  <td className="td_left"></td>
                </tr>
              </tbody>
            </table>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon blue">승인불가</span>
                    <button className="name">홍길동103 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">수고하셨습니다.</div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <div className="com_input_wrap flex_between">
                <select className="select">
                  <option value="승인 불가">승인 불가</option>
                  <option value="승인">17시</option>
                </select>
                <select className="select">
                  <option value="2기 기수 적용">2기 기수 적용</option>
                </select>
              </div>
              <textarea className="textarea" placeholder="내용 입력"></textarea>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopClassRegister open={modalClassRegisterOpen} close={() => setModalClassRegisterOpen(false)}/>
      <PopClassChange open={modalClassChangeOpen} close={() => setModalClassChangeOpen(false)} />
    </main>
  );
}

export default Assignment;
